import { put, takeEvery } from "redux-saga/effects";
import { languageActions } from "./language.slice";

const langs = [{ id: "en", name: "En" }];

function* getLangList() {
	yield put(languageActions.setList(langs));
}

export function* watchLanguage() {
	yield takeEvery(languageActions.getList, getLangList);
}
